import { render, staticRenderFns } from "./ModalComparativePreviousTournaments.vue?vue&type=template&id=73e33bb4&scoped=true&"
import script from "./ModalComparativePreviousTournaments.vue?vue&type=script&lang=js&"
export * from "./ModalComparativePreviousTournaments.vue?vue&type=script&lang=js&"
import style0 from "./ModalComparativePreviousTournaments.vue?vue&type=style&index=0&id=73e33bb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e33bb4",
  null
  
)

export default component.exports